import React , {Component} from "react";
import { connect } from 'react-redux';
import styled from 'styled-components'
import Header from '../Header/header'
import MyFooter from "../Footer/footer";
import Questions from './questions'
import HelpForm from './helpform'
import { Layout } from 'antd'
const { Content } = Layout

const Contentstyled = styled(Content) `
position: relative;
display: flex;
background: white!important;
`

const LeftSide = styled.div `
width: 100%;
top: auto;
overflow-x: hidden;
left: 0;
`

const RightSide = styled.div `
width: 100%;
top: auto;
overflow-x: hidden;
`

 class Faq extends Component {
/*
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
      }
    });
  }*/
  render () {
    return (
      <Layout  style={{ minHeight: '100vh', backgroundColor: '#FEF3C0'}}>
        <Header />
          <Contentstyled>
            <LeftSide>
              <Questions />
            </LeftSide>
            <RightSide>
              <HelpForm />
            </RightSide>
          </Contentstyled>
        <MyFooter />
      </Layout>
    );
  }
}


const mapStateToProps = globalReducers => globalReducers;

const connectedFaq = connect(mapStateToProps, null)(Faq);
export default connectedFaq;
